
<div class="toggle-btn">
    <input type="checkbox" id={{name}} class="checkbox" />
    <label for={{name}} class="toggle"></label>
    <div class="label">{{label}}</div>
</div>

